module.exports = __webpack_public_path__ + "media/בובה.7d33b7b8.mp3";